<template>
  <div class="hostingPharmacy">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="药房" label-width="60px">
        <DicInput @fieldId="fieldName($event,'pharmacyName')" :initName="searchForm.pharmacyName" :dicType="8"></DicInput>
      </el-form-item>
      <el-form-item label="代理商" label-width="60px">
        <DicInput @fieldId="fieldId($event,'operatorId')" :initName="searchForm.operatorId" :dicType="6"></DicInput>
      </el-form-item>
      <el-form-item label="未支付月份" >
        <el-select v-model="searchForm.unpayMonth" placeholder="请选择">
        <el-option
            v-for="item in 12"
            :label="item"
            :value="item">
        </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="name"
            label="名称">
        </el-table-column>
        <el-table-column
            prop="code"
            label="编号">
        </el-table-column>
        <el-table-column
            prop="address"
            label="地址">
        </el-table-column>
        <el-table-column
            prop="connectPerson"
            label="联系人">
        </el-table-column>
        <el-table-column
            prop="phone"
            label="电话">
        </el-table-column>
        <el-table-column
            prop="email"
            label="邮箱">
        </el-table-column>
        <el-table-column
            prop="waiToPayMonth"
            label="未结算月份数">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">查看账单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="90%">
      <el-form :inline="true" :model="searchBillForm" class="demo-form-inline" label-width="90px">
        <el-form-item label="时间范围">
          <el-date-picker
              v-model="searchBillForm.time"
              type="daterange"
              value-format="yyyy-MM-dd"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" @click="BillsList" style="margin-left: 20px">查询<i
              class="el-icon-search el-icon--right"></i></el-button>
          <el-button type="info" @click="Billsclear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
          <el-button type="success" @click="settlement">结算<i class="el-icon-s-promotion el-icon--right"></i></el-button>
        </el-form-item>
      </el-form>
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableBillsData"
          max-height="600"
          ref="multipleTable"
          style="width: 100%"
          @row-click="selectSelection"
          @select="selectSelection"
      >
        <el-table-column
            :selectable='selectEnable'
            type="selection"
            label="全选"
            width="55">
        </el-table-column>
        <el-table-column
            prop="date"
            label="日期">
        </el-table-column>
        <el-table-column
            prop="pharmacyName"
            label="药房名称">
        </el-table-column>
        <el-table-column
            prop="dosage"
            label="总剂量">
        </el-table-column>
        <el-table-column
            prop="cupAmount"
            label="总杯数">
        </el-table-column>
        <el-table-column
            prop="prescriptionAmount"
            label="总处方数">
        </el-table-column>
        <el-table-column
            prop="prescriptionDaysAmount"
            label="总处方天数">
        </el-table-column>
        <el-table-column
            prop="payTime"
            label="结算时间">
        </el-table-column>
        <el-table-column
            prop="payed"
            label="是否结清">
          <template slot-scope="scope">
            <span>{{ scope.row.payed ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="payed"
            label="金额">
          <template slot-scope="scope">
            <span v-if="rowData.paymentWay===0">{{ scope.row.doseBill }}</span>
            <span v-if="rowData.paymentWay===1">{{ scope.row.cupBill }}</span>
            <span v-if="rowData.paymentWay===2">{{ scope.row.prescriptionBill }}</span>
            <span v-if="rowData.paymentWay===3">{{ scope.row.prescriptionDayBill }}</span>
            <span v-if="rowData.paymentWay===4">其他</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="安全确认"
        :visible.sync="settlementVisible"
        :close-on-click-modal="false"
        width="500px"
    >
      <el-form :inline="true" ref="determineForm" :model="determineForm" :rules="rules">
        <el-form-item label="用户密码" label-width="150px" prop="password">
          <el-input v-model="determineForm.password" type="password" size="medium" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="checkCode" label-width="150px">
          <el-input
              v-model.trim="determineForm.checkCode"
              type="text"
              placeholder="请输入验证码"
              autocomplete="off"
              size="medium">
            <img :src="checkCodeImage" slot="suffix"
                 class="send-code" @click="sendVerifyCode" alt=""/>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="determine('determineForm')">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import DicInput from "@/components/DicInput";
import {getDay} from "@/service/common";

export default {
  name: "hostingPharmacy",
  data() {
    return {
      tableData: [],
      tableBillsData: [],
      searchForm: {
        pharmacyName: '',
        operatorId: '',
        unpayMonth: '',
      },
      searchBillForm: {
        time: [],
      },
      checkCodeImage: '',
      requestId: '',
      modelTitle: '查看账单',
      dialogVisible: false,
      determineForm: {
        password: '',
        checkCode: ''
      },
      rules: {
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
        checkCode: [
          {required: true, message: "请输入验证码", trigger: "blur"},
        ],
      },
      rowData: {},
      settlementVisible: false,
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      GetOtherConfig: '',
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput,
  },
  created() {
    this.GetOtherConfig = JSON.parse(window.utils.storage.getter("GetOtherConfig")) || 3;
   this.searchForm.unpayMonth=this.GetOtherConfig.unpayMonth
  },
  methods: {
    //表格多选处理
    selectSelection(row, selection) {
      let rows
      if (row.length >= 1) { // 判断输入框还是表格
        rows = selection
      } else {
        rows = row
      }
      let obj = []
      for (let i = 0; i <= rows.index; i++) {
        if(!row.payed){
          if(!this.tableBillsData[i].payed){
            obj.push(this.tableBillsData[i])
          }
        } else {
          return  false
        }
      }
      this.toggleSelection(obj)
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    selectEnable(row, rowIndex) {
      return !row.payed
    },
    // 结算
    settlement() {
      if (this.$refs.multipleTable.selection.length >= 1) {
        this.checkImageGet()
      } else {
        this.$message.error('请选择结算账单');
      }
    },
    determine(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let userJson = window.utils.storage.getter('userJson')
          let data = {
            ...this.determineForm,
            userName: userJson.userName,
            requestId: this.requestId,
          }
          this.axios.post("api/Login", data).then((res) => {
            if (res.data.userType === 0) {
              let ids = []
              let start = ''
              let end = ''
              let arr = this.$refs.multipleTable.selection
              arr.forEach((item, index) => {
                ids.push(item.id)
                if (arr.length === 0) {
                  start = item.year + '-' + item.month + '-1'
                  end = item.year + '-' + (item.month + 1) + '-1'
                } else {
                  if (index === 0) {
                    start = item.year + '-' + item.month + '-1'
                  }
                  if (arr.length === index + 1) {
                    end = item.year + '-' + (item.month + 1) + '-1'
                  }
                }
              })
              let datas = {
                pharmacyId: this.rowData.id,
                start: start,
                end: end,
              }
              this.axios
                  .put("/Statistics/PharmacyStatistics/Pay", ids, {params: datas})
                  .then((res) => {
                    this.$message({
                      message: '操作成功',
                      type: 'success'
                    });
                    this.settlementVisible = false
                    this.BillsList()
                  })
            } else {
              this.$message.error('该用户没有权限');
            }
          })
        } else {
          return false;
        }
      });
    },
    checkImageGet() { // 获取图形验证码
      this.axios.get('api/Login/CheckImageGet').then((res) => {
        this.checkCodeImage = this.axios.defaults.baseURL + res.data.imageData
        this.requestId = res.data.requestId
        this.determineForm = {
          password: '',
          checkCode: ''
        }
        this.settlementVisible = true
      })
    },
    //重新获取图片
    sendVerifyCode() {
      this.checkImageGet()
    },
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    fieldId(item, name) {
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    fieldName(item, name) {
      if (item.name) {
        this.searchForm[name] = item.name
      } else {
        this.searchForm[name] = ''
      }
    },
    clear() {
      this.searchForm = {
        pharmacyName: '',
        operatorId: '',
        unpayMonth: '',
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    Billsclear() {
      this.searchBillForm = {
        time: [],
      }
      this.BillsList()
    },
    editorClick(row) {
      this.modelTitle = '查看账单'
      this.rowData = row
      this.BillsList()
    },
    BillsList() {
      let t = new Date();
      let d = t.getDate();
      let m = t.getMonth();
      let y = t.getFullYear();
      let start
      if (m === 1) { // 1月31号
        if (d === 31) {
          start = new Date(y - 1, 12, 30)
        } else {
          start = new Date(y - 1, 12, d)
        }
      } else {
        start = new Date(y, m - Number(this.rowData.waiToPayMonth), d)
      }
      let data = {
        startDate: this.searchBillForm.time[0] || this.dayjs(start).format('YYYY/MM/DD'),
        endDate: this.searchBillForm.time[1] || this.dayjs(new Date()).format('YYYY/MM/DD'),
        pharmacyId: this.rowData.id,
        feeByDose: this.GetOtherConfig.feeByDose,
        feeByCup: this.GetOtherConfig.feeByCup,
        feeByPrescription: this.GetOtherConfig.feeByPrescription,
        feeByPrescriptionDay: this.GetOtherConfig.feeByPrescriptionDay,
      }
      this.axios
          .get("/Statistics/PharmacyStatistics/GetMonthBills", {params: data})
          .then((res) => {
            this.tableBillsData = res
            this.tableBillsData.forEach((item, index) => {
              item.date = item.year + '-' + item.month
              item.index = index
            })
          })
      this.dialogVisible = true
    },
    deleteClick(flag) {
      let data = {
        id: flag.id
      }
      this.axios
          .delete("/api/Pharmacy/GetDelegatePharmacy", {params: data}).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      }).finally(error => {
        this.init()
      })
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },

    // list
    init() {
      let data = {
        pharmacyName: this.searchForm.pharmacyName,
        operatorId: this.searchForm.operatorId,
        isDelegate: true,
        unpayMonth:  this.searchForm.unpayMonth,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("/api/Pharmacy/GetDelegatePharmacy", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.hostingPharmacy {

}
</style>